import React from "react";
import { StarIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { testimonials } from "../../data/landing";
export function Testimonials() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-246" data-mp="3mh2bjwf1lign">
      <div className="mx-auto max-w-5xl" data-id="element-247" data-mp="3mf7rslfibwe5">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-248" data-mp="3r78xfoi66ov7">
          What colleagues are saying <em className="italic text-skydeep" data-id="element-249" data-mp="fxenz44vs9">about Case Lab™</em>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-250" data-mp="421i2vhw2ed0">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-navy/10" data-id="element-251" data-mp="91e1155n31ab">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-252" data-mp="dzxs1jz3b39j">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-peach text-peach" aria-hidden="true" data-id="element-253" data-mp="2avdffze25yr8" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[16px] leading-relaxed text-ink/85" data-id="element-254" data-mp="1sl2lnrrgllyg">“{t.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-255" data-mp="1ntkicx1yr9ab">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-sky" loading="lazy" data-id="element-256" data-mp="1ity9ezt64f7b" />
                <div data-id="element-257" data-mp="1euz4hf7fsifv">
                  <p className="font-bold text-navy" data-id="element-258" data-mp="1erbe2oxagc5d">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-259" data-mp="2biveu2ca6hin">
                    {t.role} · {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-260" data-mp="22gvy7b56hfg8">
          <CTAButton label="I want to join them" data-id="element-261" data-mp="1xjw0bnihfj07" />
        </div>
      </div>
    </section>;
}